import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { cancellationPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/policiesQueryOptions'
import { taxAndFeesPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/taxAndFeesQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const policesSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z.enum(['name']).catch('name'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
  tab: z.enum(['cancellation', 'tax&Feeds']).catch('cancellation'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/site-customization/policies/'
)({
  validateSearch: (search) => policesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const cancelation = queryClient.ensureQueryData(
      cancellationPoliciesQueryOptions(siteId, auth.token!)
    )
    const taxes = queryClient.ensureQueryData(
      taxAndFeesPoliciesQueryOptions(siteId, auth.token!)
    )

    return {
      cancelation,
      taxes,
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
